import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../button/button.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sr-submit-success-modal',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './sr-submit-success-modal.component.html',
  styleUrl: './sr-submit-success-modal.component.scss'
})
export class SrSubmitSuccessModalComponent {
  @Input() srNumber: string = "";
  @Output() onClose = new EventEmitter();

  // This method is used to close success modal
  closeSuccessModal() {
    this.onClose.emit();
  }
}
